import { HttpApiSmallSvgIcon } from '@commercetools-docs/ui-kit';

export default HttpApiSmallSvgIcon;
